import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { ErrorHandlers } from '../../../../core/helpers/errorhandlers';
import { Notification } from '../../../../core/helpers/notification';
import { Roles, RoleUpdate, NewRole } from '../../../models/request/shareReq';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { TokenService } from '../../../../core/tokenManagement/token.service';

@Component({
  selector: 'app-sys-settings',
  templateUrl: './sys-settings.component.html',
  styleUrls: ['./sys-settings.component.css']
})
export class SysSettingsComponent implements OnInit {
  userPermission;
  roleresponse: Roles;
  preroleUpdate = new RoleUpdate();
  roleUpdate = new RoleUpdate();
  newRole = new NewRole();
  clientID:string;
  rolesOnly;
  isLoading:boolean=false;
  constructor(private fb:FormBuilder,private sharedservice:SharedService,private notservice: Notification, private errorhandler: ErrorHandlers, private tokenservice:TokenService) {
   }

  ngOnInit() {
    this.getUserPermission();
    this.getRoles();
    this.getClientID();
  }


  getClientID(){
    this.clientID = this.tokenservice.getclientID();
  }

  getUserPermission(){
    this.userPermission = Object.keys(this.sharedservice.permissions)
 }

 getRoles(){
    this.sharedservice.getRoles().subscribe(
      data=>{
         this.roleresponse = data['roles'];           
      },
      error=>{
        this.errorhandler.customclienterrors("Failed", error.status, error.error.responseMessage);
      }
    )
 }


 onRoleUpdateChange(arr:Roles){
    this.roleUpdate.permissions = arr.userPermission;
    this.roleUpdate.userRole = arr.userRole;
 }

 updateRole(){
   this.isLoading = true;
   this.roleUpdate.clientId = this.clientID['clientID'];
   this.roleUpdate.override = true;
    this.sharedservice.setRole(this.roleUpdate).subscribe(
      data=>{
          this.notservice.Success("Successful","Role updated");
          this.isLoading = false;
          this.preroleUpdate = new RoleUpdate();
          this.roleUpdate = new RoleUpdate();
          this.ngOnInit();
      },
      error=>{
        this.errorhandler.customclienterrors("Failed", error.status, error.error.responseMessage);
        this.isLoading = false;
      }
    )
 }


 createRole(){
  this.isLoading = true;
  this.newRole.clientId = this.clientID['clientID'];
   this.sharedservice.newRole(this.newRole).subscribe(
     data=>{
         this.notservice.Success("Successful","Role Created");
         this.isLoading = false;
         this.ngOnInit();
     },
     error=>{
       this.errorhandler.customclienterrors("Failed", error.status, error.error.responseMessage);
       this.isLoading = false;
     }
   )
}

//  updateRole(){

//  }


}
